import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { fetchCountSuccess } from './actions';
const reducers = handleActions({
    [`${fetchCountSuccess}`]: (state, action)=>action.payload.count
}, 0);
export default {
    [reduxKey]: reducers
};
